import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import {
  MIDDLE_WARE_BASE_URL_v1,
  REQUEST_ALTERNATIVE_SCHEDULE,
} from "../../../utils/CONSTANTS";

const initialState = {
  requestAlternativeScheduleState: "pending",
  requestAlternativeScheduleData: null,
  requestAlternativeScheduleMessage: "",
};

export const requestAlternativeSchedule = createAsyncThunk(
  "post/requestAlternativeSchedule",
  async (data: any) => {
    const response = axios.postRequest(
      MIDDLE_WARE_BASE_URL_v1() + REQUEST_ALTERNATIVE_SCHEDULE(),
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  }
);

const requestAlternativeScheduleSlice = createSlice({
  name: "requestAlternativeSchedule",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(
        requestAlternativeSchedule.pending,
        (requestAlternativeScheduleState) => {
          requestAlternativeScheduleState.requestAlternativeScheduleState =
            "pending";
        }
      )
      .addCase(
        requestAlternativeSchedule.fulfilled,
        (requestAlternativeScheduleState, action) => {
          let tempRes = action.payload;
          if (typeof tempRes === "string") {
            tempRes = JSON.parse(tempRes);
          }

          requestAlternativeScheduleState.requestAlternativeScheduleState =
            "fulfilled";
          requestAlternativeScheduleState.requestAlternativeScheduleData =
            tempRes;

          requestAlternativeScheduleState.requestAlternativeScheduleMessage =
            tempRes ? tempRes.message : "";
          //console.log("Insisde Slice ", tempRes);
        }
      )
      .addCase(
        requestAlternativeSchedule.rejected,
        (requestAlternativeScheduleState) => {
          requestAlternativeScheduleState.requestAlternativeScheduleState =
            "failed";
        }
      ),
});

export const requestAlternativeScheduleDetails = (state: any) =>
  state.requestAlternativeSchedule;

export default requestAlternativeScheduleSlice.reducer;
